import React from 'react';
import { Box, Theme, Typography } from '@material-ui/core';
import { unpackToDateTime } from '@campfire/hot-date';
import { createStyles, makeStyles } from '@material-ui/styles';
import { ProfileAvatar } from '../ProfileAvatar';
import { CommentActions } from './CommentActions';
import { useUser } from '../../global/auth/useUser';
import { StatusChip } from '../chips/StatusChip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    info: {
      marginLeft: '1rem',
      '& .name': {
        fontWeight: 550,
        fontSize: '.9em',
        color: theme.color.grey.neutral400,
      },
      '& .time': {
        fontSize: '0.75rem',
        fontWeight: 400,
        color: theme.color.grey.neutral200,
        marginTop: '-2px',
      },
    },
    actionIcon: {
      color: theme.color.grey.neutral300,
    },
  })
);

interface CommentHeaderProps {
  volunteerId: string;
  profile: {
    lastName: string;
    preferredName: string;
    avatarUrl?: string | null;
  };
  time: string;
  showCommentAction: boolean;
  handleAction: (type: string) => void;
  category?: string;
}

export function CommentHeader({
  volunteerId,
  profile,
  time,
  showCommentAction,
  handleAction,
  category,
}: CommentHeaderProps) {
  const classes = useStyles();
  const { getVolunteerIdentity } = useUser();
  const { volunteerId: volunteerIdentityId } = getVolunteerIdentity();
  const name = `${profile.preferredName} ${profile.lastName}`;

  const categoryColour = category === 'Application' ? '#919191' : '#948CFF';

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <Box className={classes.container}>
        <Box>
          <ProfileAvatar profile={profile} />
        </Box>
        <Box className={classes.info}>
          <Typography className='name'>{name}</Typography>
          <Typography className='time'>{unpackToDateTime(time).toFormat('hh:mm a, LLLL dd yyyy')}</Typography>
        </Box>
        {showCommentAction && volunteerId === volunteerIdentityId && (
          <Box>
            <CommentActions onClick={handleAction} />
          </Box>
        )}
      </Box>
      {category && <StatusChip status={category} bgcolor={categoryColour} tiny />}
    </Box>
  );
}
